import React, { useEffect, useRef, useState } from 'react'
import { ajaxPerso, fetchShopifyItems } from '../../../fnc'
import ShopifySearchProduct from '../ShopifySearchProduct';
import ModalSpecialPromo from '../ModalSpecialPromoV2';
import EmptyModal from '../EmptyModal';
import moment from 'moment';
import SheetCapture from '../SheetCapture';

const emptyPromo = () => ({ item: null, promo: null });

export default function AddPromo(props){
	const { info, shopSelected } = props;
	const [newPromo, setNewPromo] = useState(emptyPromo());
	const [dataSheet, setDataSheet] = useState(false);
	const [newPromoList, setNewPromoList] = useState(false);
	const [newPromoListResult, setNewPromoListResult] = useState(false);
	const [submitDisabled, setSubmitDisabled] = useState(false);
	const [removeCostSecurity, setRemoveCostSecurity] = useState(false);
	const [showSecureModal, setShowSecureModal] = useState(false);
	const refPass = useRef(null);

	const resetCreation = () => {
		setNewPromo(emptyPromo());
		setNewPromoList(false);
		setNewPromoListResult(false);
		setSubmitDisabled(false);
	};

	useEffect(() => {
		resetCreation();
	}, [shopSelected]);

	useEffect(() => {
		if(!Array.isArray(dataSheet) || dataSheet.length === 0) return;
		setSubmitDisabled(false);

		const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
		const validRows = dataSheet.filter(row => dateTimeRegex.test(row.starting_date) && dateTimeRegex.test(row.ending_date));
		if(validRows.length === 0){
			info({error: 'The date format is not correct. Please use the format: 2023-12-21 23:59:00'});
			setNewPromoList([]);
			return;
		}

		fetchShopifyItems({shop: shopSelected.id, skuList: validRows.map(row => row.sku)}, response => {
			if(response.success && response.data.length > 0){
				const matchedItems = validRows.reduce((items, row) => {
					const shopifyItem = response.data.find(item => row.sku == item.sku);
					if(shopifyItem) items.push({...row,
						id_product_shopify: shopifyItem.id_product_shopify,
						id_variant_shopify: shopifyItem.id_variant_shopify,
						id_marketplace: shopSelected.id,
						original_price: shopifyItem.price
					});
					return items;
				}, []);
				setNewPromoList(matchedItems);
			}else setNewPromoList([]);
		});
	}, [dataSheet, info, shopSelected]);

	const submitPromo = () => {
		const request = {
			id_marketplace: props.shopSelected.id,
			id_product_shopify: newPromo.item.id_product_shopify,
			id_variant_shopify: newPromo.item.id_variant_shopify,
			change_type: newPromo.promo.value_type,
			change_value: newPromo.promo.value,
			original_price: newPromo.item.price,
			starting_date: moment.unix(newPromo.promo.startingDate).format('YYYY-MM-DD HH:mm:ss'),
			ending_date: moment.unix(newPromo.promo.endingDate).format('YYYY-MM-DD HH:mm:ss'),
			uid: props.getUser().uid
		};
		if(newPromo.promo.tempOriginalPrice > 0) request.temp_original_price = newPromo.promo.tempOriginalPrice;

		ajaxPerso({api: 'shopify', trigger: 'add_promo', method: 'POST', removeCostSecurity, json: JSON.stringify(request)}, response => {
			setSubmitDisabled(false);
			if(response && response.success){
				props.info({success: 'Promo saved.'});
				setNewPromo(emptyPromo());
				if(props.onPromoCreated) props.onPromoCreated();
			}else props.info({error: (response && response.errors) || 'Unable to save promo.'});
		});
	};

	const submitPromoList = () => {
		let completed = 0;
		let hasSavedPromo = false;
		const results = [];
		newPromoList.forEach((promo, index) => {
			ajaxPerso({
				api: 'shopify',
				trigger: 'add_promo',
				removeCostSecurity,
				method: 'POST',
				json: JSON.stringify({...promo, uid: props.getUser().uid})
			}, response => {
				const success = Boolean(response && response.success);
				hasSavedPromo = hasSavedPromo || success;
				results[index] = {res: response && response.resAddNew, errors: response && response.errors};
				setNewPromoListResult(results.slice());
				completed++;
				if(completed === newPromoList.length){
					setSubmitDisabled(false);
					if(hasSavedPromo && props.onPromoCreated) props.onPromoCreated();
				}
			});
		});
	};

	const saveNewPromo = () => {
		setSubmitDisabled(true);
		if(Array.isArray(newPromoList) && newPromoList.length > 0) submitPromoList();
		else submitPromo();
	};

	const sheetCount = Array.isArray(dataSheet)? dataSheet.length : 0;
	const matchedSheetCount = Array.isArray(newPromoList)? newPromoList.length : 0;
	const canSave = Boolean((newPromo.item && newPromo.promo) || matchedSheetCount > 0);

	return <div className={props.className || ''}>
		<section className="promo-create">
			<header className="promo-create__header">
				<div>
					<h2>Create a new promo</h2>
					<p>Choose one product and set its promotion, or upload a spreadsheet to schedule several at once.</p>
				</div>
				<a className="promo-create__template" target="_blank" rel="noopener noreferrer" href="https://tools.ehub.work/DL/template_promo_creation.xlsx"><i className="bi bi-download mr-1" aria-hidden="true" />Download sheet template</a>
			</header>
			<div className="promo-create__body">
				<div className="promo-create__actions">
					<div className="promo-create__action-group">
						<span className="promo-create__action-label">Bulk creation</span>
						<SheetCapture
							{...props}
							className="btn btn-outline-primary promo-create__sheet-button"
							dataSheet={dataSheet}
							onClick={resetCreation}
							onChange={setDataSheet}
							name="From Sheet"
							valuesAllowed={['sku', 'change_type', 'change_value', 'starting_date', 'ending_date', 'temp_original_price']}
							required={['sku', 'change_type', 'change_value', 'starting_date', 'ending_date']}
							ctnAdded={<div className="pt-3">
								<div className="mb-2">Download the <a target="_blank" rel="noopener noreferrer" href="https://tools.ehub.work/DL/template_promo_creation.xlsx">spreadsheet template</a>.</div>
								<div className="alert alert-primary mb-0"><ul className="mb-0"><li><b>change_type</b>: <b>percentage</b> or <b>fixed_amount</b></li><li><b>change_value</b>: the percentage discount or the requested sale price</li><li><b>starting_date</b> and <b>ending_date</b>: <b>2023-12-21 23:59:00</b></li></ul></div>
							</div>}
						/>
					</div>
					<span className="promo-create__divider">or</span>
					<div className="promo-create__action-group">
						<span className="promo-create__action-label">Single product</span>
						<ShopifySearchProduct
							{...props}
							className="btn btn-primary"
							shopId={props.shopSelected.id}
							submitDisabled={submitDisabled}
							title="Select a product"
							itemSelected={newPromo.item? newPromo.item.id_variant_shopify : null}
							onClick={resetCreation}
							updateItem={item => {
								setNewPromo({item: {...item, id_variant_shopify: parseInt(item.id_variant_shopify), price: parseFloat(item.price), compare_at_price: item.compare_at_price? parseFloat(item.compare_at_price) : null}, promo: null});
								setSubmitDisabled(false);
							}}
						/>
					</div>
					<div className="promo-create__security custom-control custom-switch">
						{showSecureModal && <EmptyModal {...props} title="Price security" body={close => <div className="p-3"><div className="alert alert-danger"><b>Warning:</b> This allows a price below product cost.</div><label>Please enter your special key:<input type="password" className="form-control mt-1" ref={refPass}/></label><div className="mt-3">Allow prices below cost?<button type="button" className="btn btn-danger ml-3" onClick={() => {
							if(refPass.current.value == 'ehubwork'){
								setRemoveCostSecurity(true);
								setShowSecureModal(false);
								close();
							}else props.info({error: 'Invalid key.'});
						}}>Yes</button><button type="button" className="btn btn-secondary ml-3" onClick={() => {
							setRemoveCostSecurity(false);
							setShowSecureModal(false);
							close();
						}}>No</button>
						</div></div>}
					/>}
						<input type="checkbox" className="custom-control-input" id="customSwitchPublished" checked={removeCostSecurity} onChange={() => setShowSecureModal(true)}/>
						<label className="custom-control-label noselect pointer" htmlFor="customSwitchPublished">Allow prices below cost</label>
					</div>
				</div>
				<div className="promo-create__selection">
					{newPromo.item? <div className="promo-create__selected-product"><span className="promo-create__selection-label">Selected product</span><strong>{newPromo.item.title || newPromo.item.sku}</strong><span>SKU: {newPromo.item.sku || '—'} · Current price: {newPromo.item.price}</span></div> : <div className="promo-create__selection-empty"><i className="bi bi-box-seam" aria-hidden="true" />Select a product to configure its promotion.</div>}
					{newPromo.item && <ModalSpecialPromo
						{...props}
						title="Promotion settings"
						className="btn btn-outline-primary promo-create__settings-button"
						promoMetaObj={newPromo.promo}
						onClick={triggerProcess => {
							if(newPromo.item.id_variant_shopify) triggerProcess();
							else props.info({error: 'Please select a product first.'});
						}}
						onSubmit={promo => setNewPromo(current => ({...current, promo}))}
						price={newPromo.item.price}
						originalPrice={newPromo.item.compare_at_price || newPromo.item.price}
					/>}
					{newPromo.promo && <div className="promo-create__settings-summary"><strong>{newPromo.promo.value_type === 'percentage'? `${newPromo.promo.value}% off` : `Sale price: ${newPromo.promo.value}`}</strong><span>Promotion settings ready</span></div>}
					{canSave && <button type="button" className="btn btn-success promo-create__save" onClick={saveNewPromo} disabled={submitDisabled}>{submitDisabled? 'Saving…' : sheetCount > 0? `Create ${matchedSheetCount} promos` : 'Create promo'}</button>}
				</div>
				{sheetCount > 0 && <div className="promo-create__sheet-results"><div className="promo-create__sheet-summary">Matched <strong>{matchedSheetCount}/{sheetCount}</strong> spreadsheet products.</div><div className="promo-create__sheet-list">{Array.isArray(newPromoList) && newPromoList.map((promo, index) => {
					const result = newPromoListResult && newPromoListResult[index];
					const saved = result && result.res && (result.res.updated || result.res.processed);
					return <div key={`${promo.sku}_dataset`} className="promo-create__sheet-row"><div><strong>{promo.sku}</strong><span>{promo.change_type === 'percentage'? `${promo.change_value}% off` : `Sale price: ${promo.change_value}`}</span></div><div><span>{promo.starting_date}</span><span>{promo.ending_date}</span></div>{result && <div className="promo-create__sheet-result">{result.errors? <span className="text-danger">{result.errors.join(', ')}</span> : saved? <span className="text-success">Saved</span> : null}</div>}</div>;
				})}</div></div>}
			</div>
		</section>
	</div>;
}
